import { AnimatePresence, motion } from 'motion/react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useGetParams } from 'hooks/useGetParams';

import { Message } from '../Message/Message';
import { Confetti } from '../Confetti/Confetti';
import { Title } from 'components/Randomizer/Title/Title';

import styles from './MessagesList.module.css';

export const MessagesList = ({
  messages,
  currentState,
  winId,
  speed,
  messagesRef,
  RND_ONE_WIN,
  RND_WIN,
}) => {
  const { authorFontSize } = useGetParams();

  const isWinner =
    currentState === RND_WIN ||
    (currentState === RND_ONE_WIN && messagesRef?.length === 1);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles['wrapper']}
    >
      <AnimatePresence mode="wait">
        {isWinner && (
          <div className={styles.winnerTitle}>
            <Title line="THE WINNER" textFontSize="10.1" startDelay={0.5} />
          </div>
        )}
      </AnimatePresence>

      {currentState === RND_ONE_WIN ? (
        messagesRef?.length === 1 ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 }}
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-start',
            }}
          >
            <Message
              message={messagesRef[0].message}
              currentState={currentState}
              winId={messagesRef[0].message?.id}
              authorFontSize={authorFontSize}
              RND_ONE_WIN={RND_ONE_WIN}
              RND_WIN={RND_WIN}
            />
          </motion.div>
        ) : null
      ) : (
        <div className={styles.messagesWrapper}>
          <TransitionGroup className={styles.messages}>
            {messages.length > 0 &&
              messages.map((item, i) => (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                >
                  <Message
                    key={item.id}
                    message={item.message}
                    currentState={currentState}
                    winId={winId}
                    authorFontSize={authorFontSize}
                    RND_ONE_WIN={RND_ONE_WIN}
                    RND_WIN={RND_WIN}
                  />
                </CSSTransition>
              ))}
          </TransitionGroup>
        </div>
      )}

      {isWinner && <Confetti />}
    </motion.div>
  );
};
